<template>
  <div>
    <div class="row justify-content-center">
      <div class="col-8 text-center text-navy mb-3">
        Please input any properties where financed livestock will be located.
        Ottley requires third-party access to these properties to fund. Movement
        of financed animals will be monitored through the National Livestock
        Identification System (NLIS).
      </div>
      <div
        class="col-12 col-lg-7"
        v-if="onboardingAccount.is_completed == false"
      >
        <pic-search-form
          :showAdminFields="false"
          @add="addProperty"
          :key="keyPicForm"
          :prefill="true"
          :initial_lead="initial_lead"
          :initial_property="initial_property"
        ></pic-search-form>
      </div>
      <div
        :class="
          onboardingAccount.is_completed == false
            ? 'col-12 col-lg-5 border-left pr-lg-0'
            : 'col-8'
        "
      >
        <div class="text-uppercase text-light-gold mb-2">
          Properties Created
        </div>
        <div>
          <div class="row">
            <div class="col-2 font-weight-bold">PIC</div>
            <div class="col-4 font-weight-bold">Name</div>
            <div class="col-3 font-weight-bold">Property Type</div>
            <div class="col-3 font-weight-bold">Owned</div>
            <div class="col-12">
              <hr class="my-2" />
            </div>
          </div>

          <div
            v-if="properties.length == 0"
            class="row col-12 mt-2 text-grey fa-sm"
          >
            No data
          </div>
          <div v-for="(addedProperty, index) in properties" :key="index">
            <div class="row">
              <div class="col-2">{{ addedProperty.pic }}</div>
              <div class="col-4">{{ addedProperty.name }}</div>
              <div class="col-3 text-capitalize">
                {{ addedProperty.property_type }}
              </div>
              <div class="col-3">
                <i
                  class="fa fa-check text-success"
                  v-if="addedProperty.pic_type == 'owned'"
                ></i>
                <i class="fa fa-times text-danger" v-else></i>

                <i
                  class="fas fa-trash text-danger has-interaction px-1 float-right"
                  @click="removePic(index)"
                  v-if="onboardingAccount.is_completed == false"
                ></i>
                <i
                  class="fa fa-edit text-primary has-interaction px-1 float-right"
                  @click="editProperty(addedProperty, index)"
                  v-if="onboardingAccount.is_completed == false"
                ></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pt-4 mt-4"></div>
    <div
      class="px-5 pb-4"
      style="position: absolute; bottom: 0; left: 0; right: 0"
    >
      <div class="d-flex justify-content-between">
        <el-button class="btn-secondary" @click="updateLead('prev')">
          Previous
        </el-button>
        <div>
          <el-button
            class="btn-secondary px-4"
            @click="updateLead('save')"
            v-if="onboardingAccount.is_completed == false"
          >
            Save Progress
          </el-button>
          <el-button class="btn-secondary" @click="updateLead('next')">
            Next
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PicSearchForm from "../../../../common/PicSearchForm.vue";
export default {
  components: { PicSearchForm },
  props: {
    initial_lead: {
      type: Object,
    },
    onboardingAccount: {
      type: Object,
    },
  },
  data() {
    return {
      properties: [],
      keyPicForm: 1,
      initial_property: null,
    };
  },
  created() {
    this.loadProperties();
  },
  methods: {
    editProperty(property, index) {
      this.initial_property = { ...property, index };
      this.keyPicForm++;
    },
    removePic(index) {
      this.properties.splice(index, 1);
      this.initial_property = null;
      this.keyPicForm++;
    },
    addProperty(event) {
      console.log("addProperty");
      console.log(event);
      if (event.index !== undefined && event.index >= 0) {
        this.properties[event.index] = {
          ...event,
          address: event.extra_attributes
            ? event.extra_attributes.address.route +
              ", " +
              event.extra_attributes.address.locality +
              ", " +
              event.extra_attributes.address.postal_code +
              ", " +
              event.extra_attributes.address.administrative_area_level_1
            : "",
        };
      } else {
        let property = {
          ...event,
          address: event.extra_attributes
            ? event.extra_attributes.address.route +
              ", " +
              event.extra_attributes.address.locality +
              ", " +
              event.extra_attributes.address.postal_code +
              ", " +
              event.extra_attributes.address.administrative_area_level_1
            : "",
        };
        this.properties.push(property);
      }
      this.initial_property = null;
      this.keyPicForm++;
    },
    loadProperties() {
      if (
        this.initial_lead &&
        this.initial_lead.properties &&
        this.initial_lead.properties.length > 0
      ) {
        this.properties = this.initial_lead.properties;
      }
    },
    updateLead(step) {
      if (
        this.properties.length > 0 ||
        step === "prev" ||
        this.onboardingAccount.is_completed == true
      ) {
        let lead = this.initial_lead;
        lead.properties = this.properties;
        this.$emit("update-lead", lead, step);
      } else {
        this.$confirm(`No property added are you sure you want to continue?`)
          .then(() => {
            let lead = this.initial_lead;
            lead.properties = this.properties;
            this.$emit("update-lead", lead, step);
          })
          .catch(() => {});
      }
    },
  },
};
</script>
